// extracted by mini-css-extract-plugin
export var card = "styles-module--card--eYzTL";
export var description = "styles-module--description--77ppF";
export var image = "styles-module--image--89LsT";
export var link = "styles-module--link--+rG6A";
export var title = "styles-module--title--RrOKj";